// extracted by mini-css-extract-plugin
export default {"root":"AddVContainer_root__dL86b","add-icon":"AddVContainer_add-icon__XCvPm"};